// src/pages/admin/batches/CreateBatch.tsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BatchCreationForm from "src/components/admin/batches/BatchCreationForm";
import BatchCreationSidebar from "src/components/admin/batches/BatchCreationSidebar";
import { useToast } from "src/hooks/useToast";
import { ROUTES } from "src/routes/RouteConfig";
import { usePageHeaderStore } from "src/store/pageHeaderStore";

const CreateBatch: React.FC = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { setTitle, setDescription, reset } = usePageHeaderStore();

  useEffect(() => {
    setTitle("Create Operational Batch");
    setDescription("Link student subscription, match tutor specialization, and generate batch identity.");

    return () => reset();
  }, [setTitle, setDescription, reset]);

  const handleBatchCreationSuccess = () => {
    toast({
      title: "Batch Provisioned",
      description: "The batch has been created and deployed to the dispatch queue.",
      type: "success",
    });

    setTimeout(() => {
      navigate(ROUTES.ADMIN_BATCHES.path);
    }, 1500);
  };

  return (
    <div className="space-y-6 max-w-7xl">
      {/* Page Breadcrumb & Status Bar (matching /admin/tutors/create) */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pb-2 border-b border-slate-200">
        <div className="flex items-center gap-1.5 text-xs text-slate-500">
          <button
            type="button"
            onClick={() => navigate("/admin/dashboard")}
            className="hover:text-purple-700 transition"
          >
            Admin
          </button>
          <span>/</span>
          <button
            type="button"
            onClick={() => navigate(ROUTES.ADMIN_BATCHES.path)}
            className="hover:text-purple-700 transition font-medium"
          >
            Batch Management
          </button>
          <span>/</span>
          <span className="font-semibold text-slate-800">Create Batch</span>
        </div>

        <div className="flex items-center gap-2">
          <span className="px-2.5 py-0.5 rounded text-xs font-medium bg-emerald-50 text-emerald-700 border border-emerald-200 flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
            Ready for Dispatch
          </span>
        </div>
      </div>

      {/* Option A Asymmetric Split Console: 7 cols Form, 5 cols Live Commercial Dossier */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        {/* Left: Configuration Form Card (7 cols) */}
        <div className="lg:col-span-7 space-y-5">
          <BatchCreationForm
            onSuccess={handleBatchCreationSuccess}
            onCancel={() => navigate(ROUTES.ADMIN_BATCHES.path)}
          />
        </div>

        {/* Right: Live Commercial Dossier & Student Intelligence (5 cols) */}
        <div className="lg:col-span-5 space-y-5">
          <BatchCreationSidebar />
        </div>
      </div>
    </div>
  );
};

export default CreateBatch;
